import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _fd-c _fd-r--m _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backing_information_list_item = _resolveComponent("backing-information-list-item")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createBlock(_component_backing_information_list_item, _mergeProps({
        key: item.key
      }, { ref_for: true }, item, {
        onClick: $event => ($options.selectItem(item.key)),
        "data-qa": `${item.key}`
      }), null, 16 /* FULL_PROPS */, ["onClick", "data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}